import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { linkPage } from "@utils/router";
import { VscHistory } from "react-icons/vsc";

import { useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import { HomeService } from "@services/home.service";
import { Spiner } from "@components/loaders/spiner";
import { toRp } from "@utils/helper";
import { Mading } from "@services/dtos/home.dto";
import { useThemeStore } from "@stores/theme.store";
import { androidIsAvailableBiometric } from "@utils/android";
import "@splidejs/react-splide/css";
import moment from "moment";

import LogoHomePage from "@assets/images/logo-darulumum.png";
import {
  FcBusinessContact,
  FcCalendar,
  FcExpired,
  FcGraduationCap,
  FcHighPriority,
  FcMenu,
  FcMoneyTransfer,
  FcPlus,
  FcTodoList,
} from "react-icons/fc";
import { BiTransfer } from "react-icons/bi";
import { PiCaretRightLight } from "react-icons/pi";
import { PopupError } from "@components/general/popup";

export const DashboardPage = () => {
  const navigate = useNavigate();
  const { setAppBar } = useThemeStore((state) => state);

  const [popupError, setPopupError] = useState<boolean>(false);

  const kategori = "*";
  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";
  // const gender = dataNis?.data?.gender ?? "";

  const { data: dataUangSaku, isPending: isPendingUangSaku } = useQuery({
    queryKey: [HomeService.queries.GET_BILLS_AND_BALANCES, nis],
    queryFn: () => HomeService.billsAndBalances({ nis }),
  });

  // const { data, isPending } = useQuery({
  //   queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIOGRAPHY, nis],
  //   queryFn: () => SchoolService.studentBiography(nis),
  // });

  const { data: dataMading, isPending: isPendingMading } = useQuery({
    queryKey: [HomeService.queries.GET_MADING, kategori, "5"],
    queryFn: () => HomeService.mading(kategori, "5"),
  });

  useEffect(() => {
    // const setupUnreadInbox = setTimeout(() => androidUnreadInbox(), 1000);
    const setupBiometric = setTimeout(() => {
      localStorage.setItem("is-biometric", "false");
      androidIsAvailableBiometric();
    }, 1000);

    return () => {
      clearTimeout(setupBiometric);
      // clearTimeout(setupUnreadInbox);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    setAppBar({ title: "Beranda", show: true, leading: "home" });
  }, [setAppBar]);

  const openDetailMading = (detailMading: Mading) => {
    navigate(linkPage.MADING_DETAIL, { state: detailMading });
  };

  return (
    <>
      {/* Profile */}
      <div className="profile-header">
        <div className="tw-pt-[20px] tw-pb-[10px] tw-px-4 tw-flex tw-items-center">
          <div className="tw-grow">
            <div className="tw-flex tw-items-center">
              <div className="tw-text-white tw-text-xl tw-font-bold">
                <img src={LogoHomePage} alt="" className="tw-h-[65px]" />
              </div>
            </div>
          </div>
        </div>

        {/* <div className="tw-mb-4 tw-mx-4 tw-p-4 card-body">
          <Link
            to={linkPage.HOME_PROFILE}
            className="tw-flex tw-items-center tw-justify-between"
          >
            <div className="tw-text-left">
              <div className="tw-mb-2 tw-font-bold tw-text-xl tw-text-text-primary">
                {data?.data?.namasiswa ?? "-"}
              </div>
              <div
                className="tw-font-bold tw-text-sm tw-text-background-200"
                style={{ letterSpacing: "2px" }}
              >
                {data?.data?.kelas ?? "-"}
              </div>
              <div
                className="tw-font-bold tw-text-sm tw-text-background-200"
                style={{ letterSpacing: "1px" }}
              >
                {"Sistem Informasi Pondok"}
              </div>
            </div>
            <div>
              <img
                src={
                  isPending
                    ? MaleLogo
                    : data?.data?.foto === null || data?.data?.foto === ""
                    ? gender === "Pria" || gender === "PRIA" || gender === ""
                      ? MaleLogo
                      : FemaleLogo
                    : `https://sip2.darululumkalbar.com//assets/fotosiswa/${data?.data?.foto}`
                }
                alt={`Foto ${data?.data?.namasiswa}`}
                className="tw-rounded-full tw-object-cover tw-w-[50px] tw-h-[50px] md:tw-w-[65px] md:tw-h-[65px]"
              />
            </div>
          </Link>
        </div> */}
      </div>
      {/* end of Profile */}

      {/* Pocket */}
      <div className="tw-px-4 tw-mt-4 tw-mb-6 tw-flex tw-items-center">
        <div className="tw-w-2/3 ">
          <div className="tw-text-xs tw-text-background-400 tw-tracking-wide tw-mb-3">
            Uang saku tersisa
          </div>
          <div className="tw-text-2xl tw-font-semibold tw-text-background-100">
            {isPendingUangSaku ? (
              <Spiner />
            ) : (
              toRp(dataUangSaku?.data?.saldo ?? 0)
            )}
          </div>
        </div>

        <div className="tw-w-1/3 tw-py-2 tw-mx-auto tw-flex tw-justify-center">
          <div
            onClick={
              () =>
                navigate(
                  linkPage.FINANCE_REQUEST_VA.replace(":type", "topup"),
                  {
                    state: {
                      tagihan: false,
                      tipe: "topup",
                    },
                  },
                )
              // setPopupError(true)
            }
            className="tw-w-1/2 tw-text-center tw-items-center"
          >
            <BiTransfer className="tw-text-background-100 tw-text-[28px] card-icon" />
            <div className="tw-mt-2 tw-text-background-400 card-name">
              Top-up
            </div>
          </div>

          <div
            onClick={() => navigate(linkPage.FINANCE_POCKET)}
            className="tw-w-1/2 tw-text-center tw-items-center"
          >
            <VscHistory className="tw-text-background-100 tw-text-[28px] card-icon" />
            <div className="tw-mt-2 tw-text-background-400 card-name">
              Riwayat
            </div>
          </div>
        </div>
      </div>
      {/* end of Pocket */}

      {/* Menu */}
      <div
        // className="tw-list-item tw-list-none tw-whitespace-nowrap tw-overflow-x-auto tw-mx-4 tw-mb-4 menu"
        // style={{
        //   msOverflowStyle: "none",
        //   scrollbarWidth: "none",
        // }}
        className="tw-mb-4 tw-px-4"
      >
        <div className="tw-px-2 tw-pb-0 card-body card-body-grid">
          <div className="tw-mx-2 tw-pb-2 card-grid">
            <div
              onClick={() => navigate(linkPage.MENU_FINANCE)}
              className="tw-m-0"
            >
              <div className="bg-rotated tw-absolute tw-bg-[#ecf4ff]" />
              <FcMoneyTransfer className="card-icon tw-text-[#4D8EFF]" />
              <div className="tw-line-clamp-1 card-name">Tagihan</div>
            </div>
          </div>

          <div className="tw-mx-2 tw-pb-2 card-grid">
            <div
              onClick={() => navigate(linkPage.PERMIT_PAGE)}
              className="tw-m-0"
            >
              <div className="bg-rotated tw-absolute tw-bg-[#ffecec]" />
              <FcCalendar className="card-icon tw-text-[#ff6b6b]" />
              <div className="tw-line-clamp-1 card-name">Req. Izin</div>
            </div>
          </div>

          <div className="card-grid">
            <div
              onClick={() => navigate(linkPage.INFO_BIOGRAPH)}
              className="tw-m-0"
            >
              <div className="bg-rotated tw-absolute tw-bg-[#f5e9ff]" />
              <FcBusinessContact className="card-icon tw-text-accent-primary" />
              <div className="tw-line-clamp-1 card-name">Biodata</div>
            </div>
          </div>

          <div className="tw-mx-2 tw-pb-2 card-grid">
            <div onClick={() => navigate(linkPage.HEALTH_PAGE)}>
              <div className="bg-rotated tw-absolute tw-bg-[#e0f9f2]" />
              <FcPlus className="card-icon tw-text-[#00b894] tw-relative tw-z-10" />
              <div className="tw-line-clamp-1 card-name">Kesehatan</div>
            </div>
          </div>

          <div className="card-grid">
            <div onClick={() => navigate("/school/tafaquh")} className="tw-m-0">
              <div className="bg-rotated tw-absolute tw-bg-[#e4e8ff]" />
              <FcTodoList className="card-icon tw-text-[#00b894]" />
              <div className="tw-line-clamp-1 card-name">Tafaquh</div>
            </div>
          </div>

          <div className="tw-mx-2 tw-pb-2 card-grid">
            <div
              onClick={() => navigate(linkPage.VIOLATION_PAGE)}
              className="tw-m-0"
            >
              <div className="bg-rotated tw-absolute tw-bg-[#ffecec]" />
              <FcHighPriority className="card-icon tw-text-[#FF5C5C]" />
              <div className="tw-line-clamp-1 card-name">Pelanggaran</div>
            </div>
          </div>

          <div className="tw-mx-2 tw-pb-2 card-grid">
            <div
              onClick={() => navigate(linkPage.ACHIEVEMENT_PAGE)}
              className="tw-m-0"
            >
              <div className="bg-rotated tw-absolute tw-bg-[#eee]" />
              <FcGraduationCap className="card-icon tw-text-[#FF5C5C]" />
              <div className="tw-line-clamp-1 card-name">Prestasi</div>
            </div>
          </div>

          <div className="card-grid">
            <div
              onClick={() => navigate("/menu/other-menu")}
              className="tw-m-0"
            >
              <div className="bg-rotated tw-absolute tw-bg-[#eee]" />
              <FcMenu className="card-icon" />
              <div className="tw-line-clamp-1 card-name">Lainnya</div>
            </div>
          </div>
        </div>
      </div>
      {/* end of Menu */}

      {/* Tagihan */}
      <div className="tw-px-4 tw-mt-4">
        <div className="card-body">
          <div className="tw-w-full tw-flex tw-items-center">
            <FcExpired className="tw-h-[20px] tw-w-[20px] tw-p-1 tw-bg-[#f5e9ff] tw-text-red-500 tw-rounded-lg" />
            <div className="tw-ml-2 tw-w-[30%]">
              <div className="tw-d-block tw-text-sm tw-font-bold tw-text-red-500">
                Tagihan
              </div>
              <div className="tw-text-[10px] tw-text-text-secondary">
                per hari ini
              </div>
            </div>
            <div className="tw-ml-2 tw-w-[60%] tw-text-end">
              <div className="tw-text-lg tw-font-semibold tw-text-text-primary">
                {isPendingUangSaku ? (
                  <Spiner />
                ) : (
                  toRp(dataUangSaku?.data?.tagihan ?? 0)
                )}
              </div>
            </div>
            {/* <div className="tw-flex tw-justify-end tw-w-[10%]">
              <PiCaretRightLight />
            </div> */}
          </div>
        </div>
      </div>
      {/* end of Tagihan */}

      {/* Mading */}
      {isPendingMading ? (
        <div className="tw-mt-5 tw-py-3 tw-m-auto tw-text-center">
          <Spiner />
        </div>
      ) : (dataMading?.data ?? []).length === 0 ? (
        <></>
      ) : (
        <>
          <div className="tw-pb-20 tw-mt-2">
            <div className="tw-px-4 tw-pt-4 tw-pb-2 tw-flex tw-justify-between">
              <div className="tw-text-lg tw-font-medium tw-text-text-primary md:tw-text-2xl">
                Informasi Terkini
              </div>
              <div
                onClick={() => navigate("/mading/list")}
                className="tw-flex tw-items-center float-right tw-text-xs tw-text-accent-primary md:tw-text-sm"
              >
                Lihat Semua
              </div>
            </div>
            <Splide
              options={{
                perPage: 1,
                arrows: false,
              }}
              className="slider-no-dots"
            >
              {isPendingMading
                ? [1, 2, 3].map((key) => (
                    <SplideSlide key={key}>
                      <div
                        className="card tw-rounded-2xl tw-mx-2 tw-text-center tw-shadow-l tw-d-flex"
                        style={{ height: 289 }}
                      >
                        <Spiner />
                      </div>
                    </SplideSlide>
                  ))
                : (dataMading?.data ?? [])
                    .sort((a, b) => moment(b.tanggal).diff(moment(a.tanggal)))
                    .slice(0, 3)
                    .map((mading, idx) => (
                      <SplideSlide
                        className="tw-ps-4 tw-pe-2 !tw-w-10/12 tw-mb-4"
                        key={idx}
                        onClick={() => openDetailMading(mading)}
                      >
                        <div
                          className="tw-relative tw-p-4 tw-rounded-2xl tw-shadow-l tw-overflow-hidden tw-min-h-[150px]"
                          style={{
                            backgroundImage: `url(https://sip2.darululumkalbar.com/assets/mading/${mading.gambar})`,
                            backgroundSize: "cover",
                          }}
                        >
                          <div className="tw-absolute tw-bottom-2 tw-left-2 tw-right-2 tw-bg-background-100/95 tw-rounded-2xl tw-p-2 tw-border tw-border-background-200/50">
                            <div className="tw-px-2 tw-mt-2 tw-text-xs tw-font-light tw-text-text-primary">
                              {moment(mading.tanggal ?? Date.now()).format(
                                "dddd, DD MMMM YYYY",
                              )}
                            </div>
                            <div
                              className="tw-mb-0 tw-px-2 tw-mt-2 tw-text-md tw-font-medium tw-text-text-primary"
                              style={{
                                overflowWrap: "break-word",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {mading.judul}
                            </div>
                          </div>
                        </div>
                      </SplideSlide>
                    ))}
            </Splide>
          </div>
        </>
      )}
      {/* end of Mading */}

      <PopupError
        open={popupError}
        title="Fitur Tidak Tersedia"
        message="Fitur ini sedang dalam perbaikan. Kami akan segera mengaktifkannya kembali."
        textConfirm="Tutup"
        onConfirm={() => setPopupError(false)}
      />
    </>
  );
};
